export const checkIfOrgNeedsUpdate = ({ org_details }) => {
  if (
    !org_details?.name ||
    org_details?.name === "" ||
    org_details?.name === "null"
  ) {
    return true;
  }
  return false;
};
